import styled from "@emotion/styled"
import { spacingStaticMd, spacingStaticSm, spacingStaticXs } from "@porsche-design-system/components-react/emotion"
import { Skeleton } from "src/components"

export const NewsPreviewSkeleton = () => (
	<Preview data-testid="news-preview-skeleton">
		<Skeleton.Text $width="30%" size="sm" />
		<Headline>
			<Skeleton.Heading $width="70%" size="lg" />
			<Skeleton.Text $width="25%" size="sm" />
		</Headline>
		<Lines>
			<Skeleton.Text />
			<Skeleton.Text />
			<Skeleton.Text $width="60%" />
		</Lines>
		<Skeleton.Picture $aspectRatio="16/9" />
	</Preview>
)

const Preview = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${spacingStaticMd};
`

const Headline = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${spacingStaticXs};
`

const Lines = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${spacingStaticSm};
`
